module.exports = __webpack_public_path__ + "img/2c.1f02510b.svg";